import { useCallback, useEffect, useRef } from 'react';
export function useSavedCallback(callback) {
    const savedCallback = useRef(callback);
    useEffect(() => {
        savedCallback.current = callback;
    });
    return useCallback((...args) => {
        if (savedCallback.current) {
            return savedCallback.current(...args);
        }
    }, []);
}
//# sourceMappingURL=useSavedCallback.js.map